
var google_captcha_key = document.getElementById("google_captcha_key").value;
var store_access_token = document.getElementById("store_id").value;
var api_endpoint_url = document.getElementById("endpoint_url").value;
var promo_identifier = document.getElementById("promo_identifier").value;
var evs_flag = document.getElementById("evs_flag").value;
var dja_api_url = document.getElementById("dja_api_url").value;
var dja_api_token = document.getElementById("dja_api_token").value;

var registeredUserId = "";
var language = jQuery("#language").val();


if (language === 'EN') {
    var errorMessage;
    var errorMessage = `<div aria-live='polite' role='alert' class="results-title">Sorry!</div>
       <div aria-live='polite' role='alert' class="loss-msg-1">something went wrong.<br>Please try again.</div>
        <div aria-live='polite' role='alert' class="loss-msg-2"></div>`;

    // NJ Success - redirect - thanks_you_nj
    var thankYouNjMain = `<h2>THANKS FOR THAT JUICY SECRET!</h2><h3>YOUR ENTRY HAS BEEN RECEIVED. COME BACK AND ENTER EACH DAY THROUGH AUGUST 31ST, 2023 FOR MORE CHANCES TO WIN.</h3><img src="https://cdn.shopify.com/s/files/1/0628/6530/9881/files/svekta-promo-cans-large.jpg?v=1681276410">`;

    // NJ Error - redirect - already_entered
    var alreadyEnteredMainGP = `<h2>SORRY! IT LOOKS LIKE YOU’VE ALREADY ENTERED TODAY!</h2><h3>BUT WANT TO KNOW A SECRET? YOU CAN COME BACK TOMORROW (AND EVERY DAY THROUGH AUGUST 31ST, 2023) TO ENTER AGAIN!</h3><img src="https://cdn.shopify.com/s/files/1/0628/6530/9881/files/svekta-promo-cans-large.jpg?v=1681276410">`;

    // Error - redirect - already_played
    var alreadyPlayedMain = `<div aria-live='polite' role='alert' class="results-title">Sorry</div>
       <div aria-live='polite' role='alert' class="loss-msg-1">IT LOOKS LIKE YOU’VE ALREADY PLAYED THE GAME TODAY. </div>
        <div aria-live='polite' role='alert' class="loss-msg-2">BUT WANT TO KNOW A SECRET? YOU CAN COME BACK TOMORROW (AND EVERY DAY THROUGH AUGUST 31ST, 2023) TO ENTER AGAIN!</div>`;

    //var alreadyPlayedSub = "IT LOOKS LIKE YOU’VE ALREADY PLAYED THE GAME TODAY.<br><br>COME BACK EVERY DAY THROUGH MAY 5, 2023 FOR ANOTHER CHANCE TO WIN!";


    var alreadyWonMain = `<div aria-live='polite' role='alert' class="alreadyWon-results"><div aria-live='polite' role='alert' class="results-title">IT LOOKS LIKE YOU’VE EITHER:</div>    
    <div aria-live='polite' role='alert' class="loss-msg-1 alwon">ALREADY WON AN UBER DIGITAL GIFT CARD CODE PRIZE<br>OR INSTACART DIGITAL GIFT CODE PRIZE THIS WEEK.</div>
    <br>
    <div aria-live='polite' role='alert' class="loss-msg-1 alwon"><strong>OR</strong></div>
    <br>
    <div aria-live='polite' role='alert' class="loss-msg-1 alwon">ALREADY WON A CASH APP PAYMENT PRIZE.</div>
    <br>
    <div aria-live='polite' role='alert' class="loss-msg-2 alwon"><strong>THERE IS A LIMIT OF:</strong></div>
    <br>
    <div aria-live='polite' role='alert' class="loss-msg-2 alwon">ONE (1) UBER DIGITAL GIFT CARD CODE PRIZE OR ONE (1) INSTACART DIGITAL GIFT CARD CODE <br>PRIZE PER PERSON/HOUSEHOLD, PER WEEK.</div>
    <br>
    <div aria-live='polite' role='alert' class="loss-msg-1 alwon"><strong>AND</strong></div>
    <br>
    <div aria-live='polite' role='alert' class="loss-msg-2 alwon">ONE (1) CASH APP PAYMENT PRIZE PER PERSON/HOUSEHOLD THROUGHOUT THE PROMOTION PERIOD.</div>
    <br>
    <div aria-live='polite' role='alert' class="loss-msg-2 alwon">
    SEE <strong><a href="/pages/fall-official-rules">OFFICIAL RULES</a></strong> FOR MORE DETAILS.</div></div>`;
    // Success

    // Success - winner:false
    var nonWinnerMain = "";
    //var nonWinnerSub = "";

    // Success - Winner
    var winnerHeadline = "CONGRATULATIONS!";
    var winnerGiftCode_15 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">YOU HAVE WON A DIGITAL
      UBER GIFT CARD CODE GOOD FOR</div>
      <div aria-live='polite' role='alert' class="prize-amount">$20</div>
      <div aria-live='polite' role='alert' class="prize-type">TOWARDS AN UBER RIDE OR ORDER ON UBER EATS!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.</div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>
      <br><br><div aria-live='polite' role='alert' class="prize-redemption">Uber Gift Card terms and conditions apply. Uber Gift Cards are issued by The Bancorp Bank N.A.</div>`;
    var winnerGiftCode_50 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">YOU HAVE WON A DIGITAL
      UBER GIFT CARD CODE GOOD FOR</div>
      <div aria-live='polite' role='alert' class="prize-amount">$50</div>
      <div aria-live='polite' role='alert' class="prize-type">TOWARDS AN UBER RIDE OR ORDER ON UBER EATS!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.</div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>
      <br><br><div aria-live='polite' role='alert' class="prize-redemption">Uber Gift Card terms and conditions apply. Uber Gift Cards are issued by The Bancorp Bank N.A.</div>`;
    var winnerGiftCode_100 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">YOU HAVE WON A DIGITAL
      UBER GIFT CARD CODE GOOD FOR</div>
      <div aria-live='polite' role='alert' class="prize-amount">$200</div>
      <div aria-live='polite' role='alert' class="prize-type">TOWARDS AN UBER RIDE OR ORDER ON UBER EATS!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.</div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>
      <br><br><div aria-live='polite' role='alert' class="prize-redemption">Uber Gift Card terms and conditions apply. Uber Gift Cards are issued by The Bancorp Bank N.A.</div>`;
    var winnerInstacart_20 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">You have won a</div>
      <div aria-live='polite' role='alert' class="prize-amount">$20</div>
      <div aria-live='polite' role='alert' class="prize-type">DIGITAL INSTACART GIFT CODE!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>`;
    var winnerInstacart_50 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">You have won a</div>
      <div aria-live='polite' role='alert' class="prize-amount">$50</div>
      <div aria-live='polite' role='alert' class="prize-type">DIGITAL INSTACART GIFT CODE!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>`;
    var winnerInstacart_200 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">You have won a</div>
      <div aria-live='polite' role='alert' class="prize-amount">$200</div>
      <div aria-live='polite' role='alert' class="prize-type">DIGITAL INSTACART GIFT CODE!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>`;

    var winnerCashapp_20 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">You have won</div>
      <div aria-live='polite' role='alert' class="prize-amount">$20</div>
      <div aria-live='polite' role='alert' class="prize-type">VIA CASH APP!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">Don’t have a Cash App account? Create one now for free and be ready when your prize arrives.</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.      
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>`;
    var winnerCashapp_50 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">You have won</div>
      <div aria-live='polite' role='alert' class="prize-amount">$50</div>
      <div aria-live='polite' role='alert' class="prize-type">VIA CASH APP!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
       <div aria-live='polite' role='alert' class="prize-redemption">Don’t have a Cash App account? Create one now for free and be ready when your prize arrives.</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.      
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>`;
    var winnerCashapp_200 = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">You have won</div>
      <div aria-live='polite' role='alert' class="prize-amount">$200</div>
      <div aria-live='polite' role='alert' class="prize-type">VIA CASH APP!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
       <div aria-live='polite' role='alert' class="prize-redemption">Don’t have a Cash App account? Create one now for free and be ready when your prize arrives.</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their winning Game Play has been verified.      
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>`;
    var cleanResponsewinners = `<div aria-live='polite' role='alert' class="results-title">CONGRATULATIONS!</div>
      <div aria-live='polite' role='alert' class="won-msg">You have won a</div>
      <div aria-live='polite' role='alert' class="prize-amount">$200</div>
      <div aria-live='polite' role='alert' class="prize-type">Cashapp Payment!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(Subject to Eligibility)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
        Verified Game Prize winners will receive an email with redemption instructions within 6-8 weeks after their
        winning Game Play has been verified.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No additional email confirmation will be sent.</div>`;
    var cleanResponseothers = `<div aria-live='polite' role='alert' class="results-title">Sorry</div>
       <div aria-live='polite' role='alert' class="loss-msg-1">YOU DIDN’T WIN AN INSTANT WIN PRIZE TODAY.</div>
        <div aria-live='polite' role='alert' class="loss-msg-2">COME BACK EVERY DAY THROUGH MAY 5, 2023 FOR ANOTHER CHANCE TO WIN.</div>`;
    // Unused
    var timeUpMain = '';
} else {
    
    var errorMessage = `<div aria-live='polite' role='alert' class="results-title">¡LO SENTIMOS!</div>
       <div aria-live='polite' role='alert' class="loss-msg-1">algo salió mal.<br>Por favor, inténtelo de nuevo.</div>
        <div aria-live='polite' role='alert' class="loss-msg-2"></div>`;

    // NJ Success - redirect - thanks_you_nj
    var thankYouNjMain = `<div aria-live='polite' role='alert' class="results-title">¡GRACIAS POR PARTICIPAR!</div>
       <div aria-live='polite' role='alert' class="loss-msg-1">PUEDE REGRESAR Y PARTICIPAR TODOS LOS DÍAS HASTA EL 5 DE MAYO DE 2023.</div>
        <div aria-live='polite' role='alert' class="loss-msg-2"></div>`;


    // NJ Error - redirect - already_entered
    var alreadyEnteredMainGP = `<div aria-live='polite' role='alert' class="results-title">¡LO SENTIMOS!</div>
       <div aria-live='polite' role='alert' class="loss-msg-1"> PARECE QUE USTED YA HA PARTICIPADO EL DÍA DE HOY.</div>
        <div aria-live='polite' role='alert' class="loss-msg-2">PUEDE REGRESAR Y PARTICIPAR TODOS LOS DÍAS HASTA EL 5 DE MAYO DE 2023.</div>`;

    // Error - redirect - already_played
    var alreadyPlayedMain = `<div aria-live='polite' role='alert' class="results-title">LO SENTIMOS.</div>
       <div aria-live='polite' role='alert' class="loss-msg-1"> PARECE QUE USTED YA HA PARTICIPADO EN EL JUEGO DE HOY.</div>
        <div aria-live='polite' role='alert' class="loss-msg-2">¡PUEDE REGRESAR TODOS LOS DÍAS HASTA EL 5 DE MAYO DE 2023 PARA TENER OTRA OPORTUNIDAD DE GANAR!</div>`;

    var alreadyWonMain = `<div aria-live='polite' role='alert' class="alreadyWon-results"><div aria-live='polite' role='alert' class="results-title" style='margin-bottom: 20px'></div>
    <div aria-live='polite' role='alert' class="loss-msg-1 alwon">PARECE QUE:</div>
       <div aria-live='polite' role='alert' class="loss-msg-1 alwon">YA GANASTE UN CÓDIGO DIGITAL DE REGALO DE UBER O UN CÓDIGO DIGITAL DE PREMIO DE INSTACART ESTA SEMANA.</div>
       <div aria-live='polite' role='alert' class="loss-msg-1 alwon">–O–</div>
       <div aria-live='polite' role='alert' class="loss-msg-1 alwon">YA GANASTE UN PREMIO EN EFECTIVO CON PAGO POR APLICACIÓN.</div>
       <div aria-live='polite' role='alert' class="loss-msg-2 alwon">LIMITADO A:</div>
       <div aria-live='polite' role='alert' class="loss-msg-2 alwon">UN (1) CÓDIGO DIGITAL DE REGALO DE UBER O UN (1) CÓDIGO DIGITAL DE PREMIO DE INSTACART POR PERSONA/UNIDAD FAMILIAR, POR SEMANA.</div>
       <div aria-live='polite' role='alert' class="loss-msg-1 alwon">Y</div>
       <div aria-live='polite' role='alert' class="loss-msg-2 alwon">UN (1) PREMIO EN EFECTIVO DE CASH APP POR PERSONA/UNIDAD FAMILIAR DURANTE LA VIGENCIA DE LA PROMOCIÓN CONSULTA LAS BASES EN LAS <a href="/pages/cinco-official-rules">REGLAS OFICIALES</a>.</div></div>`;

    // Success - winner:false
    var nonWinnerMain = "LO SENTIMOS";
    var nonWinnerSub = " USTED NO GANÓ UN PREMIO INSTANTÁNEO EL DÍA DE HOY.<br><br>PUEDE REGRESAR TODOS LOS DÍAS HASTA EL 5 DE MAYO DE 2023 PARA TENER OTRA OPORTUNIDAD DE GANAR.";

    // Success - Winner
    var winnerHeadline = "¡FELICITACIONES!";
    var winnerUberEats_20 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡USTED HA GANADO UNA TARJETA DE REGALO DIGITAL DE UBER VÁLIDA POR</div>
      <div aria-live='polite' role='alert' class="prize-amount">$20</div>
      <div aria-live='polite' role='alert' class="prize-type">PARA UN VIAJE EN UBER O PARA UNA ORDEN EN UBER EATS!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>
      <br><br><div aria-live='polite' role='alert' class="prize-redemption">Términos y condiciones de tarjetas de regalo de Uber aplican. Tarjetas de regalo de Uber son distribuidas por The Bancorp Bank N.A.</div>`;
    var winnerUberEats_50 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡USTED HA GANADO UNA TARJETA DE REGALO DIGITAL DE UBER VÁLIDA POR</div>
      <div aria-live='polite' role='alert' class="prize-amount">$50</div>
      <div aria-live='polite' role='alert' class="prize-type">PARA UN VIAJE EN UBER O PARA UNA ORDEN EN UBER EATS!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>
      <br><br><div aria-live='polite' role='alert' class="prize-redemption">Términos y condiciones de tarjetas de regalo de Uber aplican. Tarjetas de regalo de Uber son distribuidas por The Bancorp Bank N.A.</div>`;
    var winnerUberEats_200 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡USTED HA GANADO UNA TARJETA DE REGALO DIGITAL DE UBER VÁLIDA POR</div>
      <div aria-live='polite' role='alert' class="prize-amount">$200</div>
      <div aria-live='polite' role='alert' class="prize-type">PARA UN VIAJE EN UBER O PARA UNA ORDEN EN UBER EATS!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>
      <br><br><div aria-live='polite' role='alert' class="prize-redemption">Términos y condiciones de tarjetas de regalo de Uber aplican. Tarjetas de regalo de Uber son distribuidas por The Bancorp Bank N.A.</div>`;

    var winnerInstacart_20 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡USTED HA GANADO UN CÓDIGO DIGITAL DE REGALO DE</div>
      <div aria-live='polite' role='alert' class="prize-amount">$20</div>
      <div aria-live='polite' role='alert' class="prize-type">PARA INSTACART!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>`;
    var winnerInstacart_50 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡USTED HA GANADO UN CÓDIGO DIGITAL DE REGALO DE</div>
      <div aria-live='polite' role='alert' class="prize-amount">$50</div>
      <div aria-live='polite' role='alert' class="prize-type">PARA INSTACART!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>`;
    var winnerInstacart_200 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡USTED HA GANADO UN CÓDIGO DIGITAL DE REGALO DE</div>
      <div aria-live='polite' role='alert' class="prize-amount">$200</div>
      <div aria-live='polite' role='alert' class="prize-type">PARA INSTACART!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>`;

    var winnerCashapp_20 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡GANASTE</div>
      <div aria-live='polite' role='alert' class="prize-amount">$20</div>
      <div aria-live='polite' role='alert' class="prize-type">EN EFECTIVO EN CASH APP!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">¿No tienes cuenta en Cash App? Abre una para recibir tu premio sin contatiempos.</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>`;
    var winnerCashapp_50 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡GANASTE</div>
      <div aria-live='polite' role='alert' class="prize-amount">$50</div>
      <div aria-live='polite' role='alert' class="prize-type">EN EFECTIVO EN CASH APP!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">¿No tienes cuenta en Cash App? Abre una para recibir tu premio sin contatiempos.</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>`;
    var winnerCashapp_200 = `<div aria-live='polite' role='alert' class="results-title">¡FELICITACIONES!</div>
      <div aria-live='polite' role='alert' class="won-msg">¡GANASTE</div>
      <div aria-live='polite' role='alert' class="prize-amount">$200</div>
      <div aria-live='polite' role='alert' class="prize-type">EN EFECTIVO EN CASH APP!</div>
      <div aria-live='polite' role='alert' class="prize-disclaimer">(SUJETO A DISPONIBILIDAD)</div>
      <div aria-live='polite' role='alert' class="prize-redemption">¿No tienes cuenta en Cash App? Abre una para recibir tu premio sin contatiempos.</div>
      <div aria-live='polite' role='alert' class="prize-redemption">
      Los ganadores verificados de un Gran premio recibirán un mensaje de correo electrónico con las instrucciones de canje en el transcurso de 6 a 8 semanas después de haber verificado la Oportunidad de juego ganadora.
      </div>
      <div aria-live='polite' role='alert' class="prize-warning">No se enviará ninguna otra confirmación por correo electrónico.</div>`;

    var cleanResponseothers = `<div aria-live='polite' role='alert' class="results-title">LO SENTIMOS</div>
     <div aria-live='polite' role='alert' class="loss-msg-1">USTED NO GANÓ UN PREMIO INSTANTÁNEO EL DÍA DE HOY.</div>
        <div aria-live='polite' role='alert' class="loss-msg-2">PUEDE REGRESAR TODOS LOS DÍAS HASTA EL 5 DE MAYO DE 2023 PARA TENER OTRA OPORTUNIDAD DE GANAR.</div>`;

    // Unused
    var timeUpMain = '';
}

window.APP = {
    init: function () {
        this.formatDate()
        this.validateForm()
    },

    formatDate: function () {
        var date = document.getElementById('dob');

        function checkValue(str, max) {
            if (str.charAt(0) !== '0' || str == '00') {
                var num = parseInt(str);
                if (isNaN(num) || num <= 0 || num > max) num = 1;
                str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
            };
            return str;
        };

        date.addEventListener('input', function (e) {
            this.type = 'text';
            var input = this.value;
            if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
            var values = input.split('/').map(function (v) {
                return v.replace(/\D/g, '')
            });
            if (values[0]) values[0] = checkValue(values[0], 12);
            if (values[1]) values[1] = checkValue(values[1], 31);
            var output = values.map(function (v, i) {
                return v.length == 2 && i < 2 ? v + ' / ' : v;
            });
            this.value = output.join('').substr(0, 14);
        });

        date.addEventListener('blur', function (e) {
            this.type = 'text';
            var input = this.value;
            var values = input.split('/').map(function (v, i) {
                return v.replace(/\D/g, '')
            });
            var output = '';

            if (values.length == 3) {
                var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
                var month = parseInt(values[0]) - 1;
                var day = parseInt(values[1]);
                var d = new Date(year, month, day);
                if (!isNaN(d)) {
                    this.innerText = d.toString();
                    var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
                    output = dates.map(function (v) {
                        v = v.toString();
                        return v.length == 1 ? '0' + v : v;
                    }).join(' / ');
                };
            };
            this.value = output;
        });
    },

    validateForm: function () {
        jQuery.validator.addMethod("mustBe", function (value, element, min) {

            var today = new Date();
            var formattedValue = value.split(' / ').join('/');
            var birthDate = new Date(formattedValue);
            var age = today.getFullYear() - birthDate.getFullYear();

            if (age > min + 1) {
                return true;
            }

            var m = today.getMonth() - birthDate.getMonth();

            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age >= min;
        }, "You must be at least 21 years old to enter");

        jQuery.validator.addMethod("zipcode", function (value, element) {
            return this.optional(element) || /^\d{5}(?:-\d{4})?$/.test(value);
        }, "Please provide a valid zipcode");

        jQuery.validator.addMethod("emailValidate", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(value);
        }, "Please provide a valid email address");

        jQuery.validator.addMethod(
            "maxAgeCinco",
            function (value, element, max) {
                var date = value.split(" / ");
                var m = parseInt(date[0], 10),
                    d = parseInt(date[1], 10),
                    y = parseInt(date[2], 10);
                return y >= max;
            },
            "Please enter a valid year."
        );
    }
}

jQuery(function () {
    APP.init();
    jQuery(".spill-it").click(function () {
        if (evs_flag == 'true') {
            jQuery('#email-entry').show();
            jQuery('.sweepstake-section').show();
            jQuery('#popup-enabled-overlay').show();
            jQuery('html, body').animate({
                scrollTop: jQuery("#email-entry").offset().top - 200
            }, 1000);
        } else {
            jQuery('#entry-form').show();
            jQuery('#popup-enabled-overlay').show();
            jQuery('html, body').animate({
                scrollTop: jQuery("#entry-form").offset().top - 200
            }, 1000);
        }
    });
    jQuery(".close-promo").click(function (event) {
        event.preventDefault();
        jQuery('#email-entry').hide();
    });
    jQuery(".close-promo-form").click(function (event) {
        event.preventDefault();
        jQuery('#entry-form').hide();
        jQuery('#secret').val('');
    });
    jQuery(document).on("keyup", "#phone", function (e) {
        var ASCIICode = (e.which) ? e.which : e.keyCode
        var val = this.value;
        if (val.length == 3) {
            if (ASCIICode == 8) {
                jQuery(this).val(val.substring(0, val.length - 1));
            } else {
                this.value = val + '-';
            }
        } else if (val.length == 7) {
            if (ASCIICode == 8) {
                jQuery(this).val(val.substring(0, val.length - 1));
            } else {
                this.value = val + '-';
            }
        }
    });

    jQuery(document).on("keydown", "#phone", function (e) {
        var ASCIICode = (e.which) ? e.which : e.keyCode
        if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
            return false;
    });

    jQuery(document).on("keydown", "#zip", function (e) {
        var ASCIICode = (e.which) ? e.which : e.keyCode
        if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
            return false;
    });
});


//DJA registration api
function DJA_registration(final_values, evs_flag) {

   if(evs_flag == 'true') {	
    var api_url = api_endpoint_url + '/api/registration-wrapper';	
    var token = store_access_token;	
    //var final_values = {};	
    //final_values['email'] = final_values['email'];	
    final_values['promo_identifier'] = promo_identifier;	
    final_values['shop_url'] = Shopify.shop;	
	
    var mailid = final_values['email'];	
    var data = JSON.stringify(final_values);	
} else {	
    var api_url = dja_api_url + '/registration';	
    var token = dja_api_token;	
    var mailid = final_values['email'];	
    var data = JSON.stringify(final_values);	
}

    var settings = {
        "url": api_url,
        "method": "POST",
        "headers": {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json"
        },
        "dataType": "json",
        "data": data
    };
    jQuery.ajax(settings).done(function (responseData) {
        var response = responseData;
        console.log('reg api response' + response);
        var cleanResponseMain = '';
        var cleanResponseSub = '';
        var showSuccess = false;
        var alreadyEntered = false;
        var errorMessage;
        var errorMessage = 'Sorry, something went wrong.<br>Please try again.';
        var showLocator = false;
        // send status in url parameter for QA puporses else if no parameter then work as per API
        var urlParams = new URLSearchParams(window.location.search);
        var responseStatus = urlParams.get('statusreg');
        if (responseStatus) {
            var responseVar = responseStatus;
        }
        else {
            var responseVar = response.status;
        }
        var responseMsg = response.redirect;
        var showHideCheck = "";
        switch (responseVar) {
            case "success":
                cleanResponseMain = thankYouNjMain;
                cleanResponseSub = "";
                showSuccess = true;
                showHideCheck = false;
                hideLocator = false;
                Store_userdata(final_values);
                DL__sweepStakes();
                break;
            case "already_entered":
                cleanResponseMain = alreadyEnteredMainGP;
                cleanResponseSub = "";
                showSuccess = true;
                alreadyEntered = true;
                hideLocator = false;
                break;
            case "not_eligible":
                cleanResponseMain = alreadyEnteredMainGP;
                cleanResponseSub = "";
                showSuccess = true;
                alreadyEntered = true;
                hideLocator = false;
                break;
            case "Missing Token":
                cleanResponseMain = errorMessage;
                break;
            case "Token Not Valid":
                cleanResponseMain = errorMessage;
                break;
            case "bad_request":
                cleanResponseMain = errorMessage;
                break;
            case "redirect":
                if (responseMsg == "already_entered") {
                    cleanResponseMain = alreadyEnteredMainGP;
                    cleanResponseSub = "";
                }
                if (responseMsg == "not_eligible") {
                    cleanResponseMain = alreadyEnteredMainGP;
                    cleanResponseSub = "";
                }
                showHideCheck = true;
                showSuccess = true;
                showLocator = true;
                break;
            case "validation":
                cleanResponseMain = errorMessage;
                break;
        }
        jQuery('.sweepstake-overlay-form').hide();
        if (showSuccess) {

            var formemail = jQuery('body .promo-form-sweepstake #email').val();
            var userEmail = formemail;
            var arrayObj = new Object();
            arrayObj.email = userEmail;
            arrayObj.promo_identifier = promo_identifier;
            arrayObj.shop_url = Shopify.shop;
            var loaddata = JSON.parse(JSON.stringify(arrayObj));

            if (evs_flag == 'true') {
                /** UPDATE PROMOTION MASTER TABLE AFTER FORM SUBMIT ***/
                jQuery.ajax({
                    type: 'POST',
                    url: api_endpoint_url + '/api/update-user-promo',
                    async: false,
                    data: loaddata,
                    dataType: 'json',
                    headers: {
                        "Authorization": 'Bearer ' + store_access_token,
                        'Accept': 'application/json',
                    },
                    success: function (result) {
                        console.log(result);
                    },
                    error: function (e, t) {
                        jQuery('body').find('#sweapsteak-email__error-message').text(e.responseJSON.message);
                    }
                });
            }

            jQuery('#entry-form').fadeOut(200);
            jQuery('#email-entry').fadeOut(200);
            jQuery('#popup-enabled-overlay').hide();
            jQuery('.sweepstake-overlay-form').hide();
            jQuery('#summer-results-winner .results').html(cleanResponseMain);
            if(showHideCheck == true){
                setTimeout(function () {
                    jQuery(".sorry_banner").fadeIn(400);
                }, 500);
            }else{
                setTimeout(function () {
                    jQuery(".thanks_banner").fadeIn(400);
                }, 500);
            }
            jQuery('.spaced-sections').hide();
            jQuery('.spaced-sections').remove();
            jQuery('.summer-promo-page-sections').hide();
            jQuery('body').addClass("no-bg-img");
            setTimeout(function () {
                jQuery("#summer-results-winner").fadeIn(400);
            }, 1000);
            jQuery('html, body').animate({
                scrollTop: jQuery("#main_msg_wrapper").offset().top-200
            }, 1000);
            jQuery("#summer-results-winner").focus();
        } else {
            jQuery('#promo-entry__error-message').html(errorMessage);
        }


    }).fail(function (data) {
        jQuery('.sweepstake-overlay-form').hide();
        const errors = data.responseJSON.errors;
        console.log(errors);
        if (Array.isArray(errors)) {
            let concatFields = '';
            jQuery.each(errors, function (index, value) {
                ;
                if ((errors.length - 1) == index) {
                    concatFields += value.replace("_", " ")
                } else {
                    concatFields += value.replace("_", " ") + ', ';
                }

            });
            const invalidmsg = 'Invalid fields submitted : ' + concatFields;
            jQuery('#promo-entry__error-message').html(invalidmsg);

            jQuery('html, body').animate({
                scrollTop: jQuery("#promo-entry__error-message").offset().top - 80
            }, 500);
            jQuery("#captcha-custom-error").addClass("hide");
        }
        jQuery("#entry-form").show();
    });

}


jQuery(document).ready(function () {
    var minAgeMssg = "You must be at least 21 years old to enter";
    var maxAgeMssg = "Please enter a valid year";
    var minAgeRequiredMssg = "Enter your date of birth";
    var emailRequiredMssg = "Email address required";
    var invalidEmailMssg = "Invalid email address";
    var firstNameRequiredMssg = "First name required";
    var lastNameRequiredMssg = "Last name required";
    var optinRulesMssg = "Please check that you agree to the official rules";
    var stateSelectionMssg = "Select a state";
    var essayRequiredMssg = "Please complete the essay";
    var essayLongMssg = "Please make sure your essay is 200 words or less";

    jQuery("#submissionForm").validate({
        rules: {
            dob: {
                required: true,
                mustBe: 21,
                maxAgeCinco: 1910
            },
            email: {
                required: true,
                emailValidate: true
            }
        },
        messages: {
            dob: {
                mustBe: minAgeMssg,
                required: minAgeRequiredMssg,
                maxAgeCinco: maxAgeMssg
            },
            email: {
                required: emailRequiredMssg
            },
            first_name: firstNameRequiredMssg,
            last_name: lastNameRequiredMssg,
            state: stateSelectionMssg,
            optin_rules: optinRulesMssg
        },
        submitHandler: function () {
            //var captcha_resp = grecaptcha.getResponse(1);
            var captcha_resp = turnstile.getResponse('#html_element');
            if (captcha_resp != '' && captcha_resp != null && captcha_resp != undefined) {
                jQuery('.sweepstake-overlay-form').show();
                jQuery('body #submissionForm').prop('disabled', true);
                var inputs = jQuery("#submissionForm").serializeArray();
                console.log(inputs);
                var final_values = {};
                final_values['cf-turnstile-response'] = captcha_resp;
                jQuery('#promo-entry__error-message').text('');

                jQuery.each(inputs, function (index, value) {
                    if (value['name'] == 'dob') {
                        var dobArr = value['value'].split(' / ');
                        final_values['dob'] = dobArr[2] + '-' + dobArr[0] + '-' + dobArr[1];
                    }
                    else {
                        final_values[value['name']] = value['value'];
                    }
                });

                if (final_values['email']) {
                    final_values['confirm_email'] = final_values['email'];
                }

                if (final_values['optin_rules'] == "on") {
                    final_values['optin_rules'] = true;
                } else {
                    final_values['optin_rules'] = false;
                }

                if (final_values['optin_rules_legal'] == "on") {
                    final_values['optin_contact'] = true;
                } else {
                    // Removed this line as the api was failing with validation errors if the value was passed as 'false'
                   // final_values['optin_contact'] = false;
                }
                if (final_values['optin_super'] == "on") {
                    final_values['optin_super'] = true;
                }

                final_values['favorite_brand'] = "";

                var lang = language.toLowerCase();
                //final_values['language'] = lang;

                delete final_values['optin_rules_legal'];
                //delete final_values['language'];
                delete final_values['confirm_email'];


                console.log(final_values);
                /* Email Validation code */
                var formemail = jQuery('body .promo-form-sweepstake #email').val();
                var userEmail = formemail;
                console.log('Email From Textbox: ', formemail);
                console.log('Email From Cookie: ', userEmail);

                var arrayObj = new Object();
                arrayObj.email = formemail;
                arrayObj.promo_identifier = promo_identifier;
                arrayObj.shop_url = Shopify.shop;
                var loaddata = JSON.parse(JSON.stringify(arrayObj));
                var return_data;
                //alert(document.cookie.indexOf('sweepstake_user_email='));
                var call_dja_api = false;

                if (evs_flag == 'true') {
                    if (document.cookie.indexOf('sweepstake_user_email=') != -1) {
                        if (formemail == userEmail) {
                            return_data = function () {
                                var tmp = null;
                                //iF we connect Sweepstake Email Validation Service
                                jQuery.ajax({
                                    type: 'POST',
                                    url: api_endpoint_url + '/api/check-email-dja-api',
                                    async: false,
                                    data: loaddata,
                                    dataType: 'json',
                                    headers: {
                                        'Authorization': 'Bearer ' + store_access_token,
                                        'Accept': 'application/json'
                                    },
                                    success: function (result) {
                                        tmp = result;
                                    },
                                    error: function (e, t) {
                                        jQuery('.sweepstake-overlay-form').hide();
                                        jQuery('body').find('#sweapsteak-email__error-message').text(e.responseJSON.message);
                                    }
                                });
                                return tmp;
                            }();
                        } else {
                            //iF we connect Sweepstake Email Validation Service
                            return_data = function () {
                                var tmp = null;
                                jQuery.ajax({
                                    type: 'POST',
                                    url: api_endpoint_url + '/api/check-email-dja-api',
                                    async: false,
                                    data: loaddata,
                                    dataType: 'json',
                                    headers: {
                                        'Authorization': 'Bearer ' + store_access_token,
                                        'Accept': 'application/json'
                                    },
                                    success: function (result) {
                                        tmp = result;
                                        jQuery('#sweapsteak-email__error-message').html(result.message).css('color', 'green');
                                        jQuery('.sweepstake-overlay-form').hide();

                                    },
                                    error: function (e, t) {
                                        jQuery('body').find('#sweapsteak-email__error-message').text(e.responseJSON.message);
                                        jQuery('.sweepstake-overlay-form').hide();
                                    }
                                });
                                return tmp;
                            }();
                        }
                    } else {
                        //iF we connect Sweepstake Email Validation Service
                        return_data = function () {
                            var tmp = null;
                            jQuery.ajax({
                                type: 'POST',
                                url: api_endpoint_url + '/api/check-email-dja-api',
                                async: false,
                                data: loaddata,
                                dataType: 'json',
                                headers: {
                                    'Authorization': 'Bearer ' + store_access_token,
                                    'Accept': 'application/json'
                                },
                                success: function (result) {
                                    tmp = result;
                                },
                                error: function (e, t) {
                                    jQuery('body').find('#sweapsteak-email__error-message').text(e.responseJSON.message);
                                    jQuery('.sweepstake-overlay-form').hide();
                                }
                            });
                            return tmp;
                        }();
                    }

                    if (return_data) {
                        if (return_data.message_id == "promo_already_submitted") {
                            call_dja_api = true;
                        }
                        if (return_data.message_id == "returning_user_same_promo") {
                            call_dja_api = true;
                        }
                        if (return_data.message_id == "promo_not_found") {
                            jQuery('#entry-form').fadeOut(200);
                            jQuery('#popup-enabled-overlay').hide();
                            jQuery("#summer-results-winner").fadeIn(400);
                            jQuery('#summer-results-winner .results').html(errorMessage);
                            jQuery('.sweepstake-overlay-form').hide();
                            return false;
                        }
                        if (return_data.message_id == "email_not_verified") {
                            jQuery('#entry-form').fadeOut(200);
                            jQuery('#popup-enabled-overlay').hide();
                            jQuery("#summer-results-winner").fadeIn(400);
                            jQuery('#summer-results-winner .results').html(errorMessage);
                            jQuery('.sweepstake-overlay-form').hide();
                            return false;
                        }
                        if (return_data.message_id == "Unauthorised") {
                            jQuery('#entry-form').fadeOut(200);
                            jQuery('#popup-enabled-overlay').hide();
                            jQuery("#summer-results-winner").fadeIn(400);
                            jQuery('#summer-results-winner .results').html(errorMessage);
                            jQuery('.sweepstake-overlay-form').hide();
                            return false;
                        }
                        if (return_data.message_id == "returning_user_different_promo") {
                            call_dja_api = true;
                        }
                        // need to remove
                        if (return_data.message_id == "email_already_send") {
                            call_dja_api = true;
                        }

                    }
                } else {
                    call_dja_api = true;
                }
                if (call_dja_api == true) {
                    //DJA API Code
                    DJA_registration(final_values, evs_flag);
                    var showSuccess = true; //Assuming DJA sends success/failure in this variable
                    if (showSuccess) {

                    }
                } else {
                    jQuery('body').find('#sweapsteak-email__error-message').text("Email address not found.");
                    jQuery('.sweepstake-overlay-form').hide();
                }
            } else {
                jQuery("#captcha-custom-error").removeClass("hide");
            }
        }
    });
});

// store user data
function Store_userdata(user_details) {
    var shop_token = jQuery("#store_id").val();
    var prmo_id = jQuery("#promo_id").val();
    var shop_url = Shopify.shop;
    var api_domain_url = jQuery('#endpoint_url').val();
    var ga_client_id = readCookie('_ga');
  
    if(ga_client_id){
        user_details['ga_client_id'] = ga_client_id;
    }
    user_details['promo_identifier'] = prmo_id;
    user_details['shop_url'] = shop_url;

    delete user_details['secret'];
    delete user_details['g-recaptcha-response'];
    delete user_details['lang'];

    user_details = JSON.stringify(user_details);
    console.log('user details');
    console.log(user_details);

    var settings = {
        "url": api_domain_url + '/api/store-user-data',
        "method": "POST",
        "headers": {
            "Authorization": "Bearer " + shop_token,
            "Content-Type": "application/json"
        },
        "dataType": "json",
        "data": user_details
    };
    jQuery.ajax(settings).done(function (result) {
        console.log(result);
    }).fail(function (e) {
        console.log(e);
    });
}

//DJA iwg api
function DJA_iwg(final_mail, evs_flag) {
    if (evs_flag == 'true') {
        var api_url = api_endpoint_url + '/api/iwg-wrapper';
        var token = store_access_token;
        var final_values = {};
        final_values['email'] = final_mail;
        final_values['promo_identifier'] = promo_identifier;
        final_values['shop_url'] = Shopify.shop;
        var data = JSON.stringify(final_values);
    } else {
        var api_url = dja_api_url + '/iwg';
        var token = dja_api_token;
        var final_values = {};
        final_values['email'] = final_mail;
        var data = JSON.stringify(final_values);
    }

    var settings = {
        "url": api_url,
        "method": "POST",
        "headers": {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json"
        },
        "dataType": "json",
        "data": data
    };
    $.ajax(settings).done(function (responseData) {
        $('#popup-enabled-overlay').hide();
        var response = responseData;
        var showSuccess = false;
        var responseVar = response.status;
        var responseMsg = response.redirect;
        var showHideCheckIwg = "";
        switch (responseVar) {
            case "redirect":
                if (responseMsg == "already_entered") {
                    showHideCheckIwg = true;
                    showSuccess = true;
                }
                break;

            case "success":
                showHideCheckIwg = false;
                showSuccess = true;
                DL__sweepStakes();
                break;

            case "error":
                showSuccess = true;
                showHideCheckIwg = true;
                break;
        }

        if (showSuccess) {
            jQuery('#entry-form').fadeOut(200);
            jQuery('#email-entry').fadeOut(200);
            jQuery('#popup-enabled-overlay').hide();
            jQuery('.sweepstake-overlay').hide();
            jQuery('.sweepstake-section').fadeOut(400);
            if(showHideCheckIwg == true){
                setTimeout(function () {
                    jQuery(".sorry_banner").fadeIn(400);
                }, 500);
            }else{
                setTimeout(function () {
                    jQuery(".thanks_banner").fadeIn(400);
                }, 500);
            }
            jQuery('.spaced-sections').hide();
            jQuery('.spaced-sections').remove();
            jQuery('.summer-promo-page-sections').hide();
            jQuery('body').addClass("no-bg-img");
            jQuery('html, body').animate({
                scrollTop: jQuery("#main_msg_wrapper").offset().top-200
            }, 1000);
            jQuery("#main_msg_wrapper").focus();
        }

    }).fail(function (data) {
        const errors = data.responseJSON.errors
        console.log(errors);
    });
}